<div class="thumbnail-renderer">
  @if (safeUrl) {
    <div>
      <img [src]="safeUrl" (click)="displayFullImg()" />
    </div>
  }
</div>
